// Dependencies
import React, { Component } from 'react';
import { Col, Row, Container, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import PqrsContainer from './../../containers/Contact/PqrsContainer';
import ServiceContainer from './../../containers/Contact/ServiceContainer';
import FrequentQuestionsContainer from './../../containers/Contact/FrequentQuestionsContainer';
import { Tab, TabList, Tabs } from 'react-tabs';

//components
import Breadcrumbs from './../../components/Global/Breadcrumbs/Breadcrumbs';
import CountdownTimer from './../../../src/components/Global/Header/CountdownTimer';

class Contact extends Component {
  constructor(props) {
    super(props);

    const currentPath = props.location.pathname;

    const pathSegments = currentPath.split('/');
    const lastSegment = pathSegments[pathSegments.length - 1];
    this.state = {
      activeTab: lastSegment
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
      this.props.history.push(`/contacto/${tab}`);
    }
  }
  render() {
    let defaultIndex;
    switch (this.state.activeTab) {
      case 'pqrs':
        defaultIndex = 0;
        break;
      case 'calificar':
        defaultIndex = 1;
        break;
      case 'faq':
        defaultIndex = 2;
        break;
      default:
        defaultIndex = 0;
        break;
    }
    return (
      <Col xs={12} className="homeContainer">
        <CountdownTimer/>
        <Row>
          <Container className="bg-primary">
            <Breadcrumbs />
            <section className="mb-4 px-4 pb-4">
              <h3 className="first-title text-center my-4 interna-loterias">Contáctenos</h3>
              <div className="tabs-page">
                <Tabs tabs fill defaultIndex={defaultIndex}>
                  <TabList className="react-tabs__tab-list tab-container">
                    <Tab
                      className="button-rounded button-rounded-puntos px-20 py5"
                      onClick={() => this.toggle('pqrs')}
                    >
                      PQRS
                    </Tab>
                    <Tab
                      className="button-rounded button-rounded-puntos px-20 py5"
                      onClick={() => this.toggle('calificar')}
                    >
                      Calificar servicio
                    </Tab>
                    <Tab
                      className="button-rounded button-rounded-puntos px-20 py5"
                      onClick={() => this.toggle('faq')}
                    >
                      Preguntas frecuentes
                    </Tab>
                  </TabList>
                </Tabs>
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="pqrs" className="p-5 text-center">
                    <PqrsContainer />
                  </TabPane>
                  <TabPane tabId="calificar" className="p-5 text-center">
                    <ServiceContainer />
                  </TabPane>
                  <TabPane tabId="faq" className="p-5 text-center">
                    <FrequentQuestionsContainer />
                  </TabPane>
                </TabContent>
              </div>
            </section>
          </Container>
        </Row>
      </Col>
    );
  }
}

export default Contact;
